// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0_esbuild@0.25.0_/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0_esbuild@0.25.0_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
#    Colors
   ========================================================================== */
/*\$mainColor:#d40621;
\$alphaLight:rgba(#fff, .5);
\$alphaDark:rgba(#000, .5);
\$placeholderTextLight:rgba(#fff, .7);
\$placeholderTextDark:rgba(#000, .7);

\$textLight: #fff;
\$textDark: #404040;
\$textThemes:#d40621;*/
/* ################## */
/* ################## */
/* ################## */
/* ################## */
body .section_index {
  font-size: 1.375em;
}
body .section_index unit-picker {
  display: block;
  margin-bottom: 80px;
}
body .section_index .signInRow {
  margin-bottom: 20px;
}
body .section_index .signInRow visiba-svg {
  width: 20px;
}
body .section_index mobile-app-promotion {
  font-size: 0.7272727273em;
  position: absolute;
  width: 120px;
  margin-top: 20px;
  left: 4%;
  z-index: 1;
}
body .section_index .pageText {
  margin-top: 50px;
}
body .section_index .pageLogo {
  margin-top: 50px;
  display: flex;
  justify-content: center;
}
body .section_index .pageLogo img {
  height: 150px;
}
body .section_index .doors {
  margin-top: 50px;
}
body .section_index .doors > div:first-child {
  margin-bottom: 40px;
}
body .section_index .doors .door {
  color: var(--c_textBody);
}
body .section_index .doors .door .cardBtn {
  padding: 20px 40px;
  box-sizing: border-box;
}
body .section_index .doors .door:nth-child(odd) {
  clear: left;
  margin-left: 0;
}
body .section_index .doors .door:nth-child(n+3) {
  margin-top: 40px;
}
body .section_index .doors .door.superoffset12 {
  margin-left: 24%;
}
body .section_index .doors .door .icon {
  float: left;
  width: 40px;
  display: flex;
  align-content: center;
  align-items: center;
  height: 50px;
}
body .section_index .doors .door .icon .noticeBadge {
  position: absolute;
  top: -1px;
  right: -6px;
  border-radius: 100%;
  background-color: var(--c_accentColor);
  text-align: center;
  font-weight: bold;
  color: var(--c_textLight);
  font-size: 0.6818181818em;
  line-height: 0.6818181818em;
  width: 1.6em;
  height: 1.6em;
  padding: 0.3333333333em 0;
  box-sizing: border-box;
  border: solid 2px var(--c_backgroundBox);
}
body .section_index .doors .door svg {
  height: 40px;
  width: 50px;
}
body .section_index .doors .door .text {
  float: left;
  margin-left: 20px;
  width: calc(100% - 60px);
}
body .section_index .doors .door .text .title {
  font-size: 1em;
  font-weight: 600;
}
body .section_index .doors .door .text .info {
  font-size: 0.7272727273em;
}
body .section_index .doors .door visiba-svg {
  width: 100%;
}
body .section_index .doors .door visiba-svg svg {
  width: 100%;
}
body .section_index .doors .door visiba-svg svg .fill {
  transition: all 0.2s ease-in-out;
}
body .section_index .full {
  background: url("//media-cdn.visibacare.com/service/public/design/headerBg.png") no-repeat center;
  background-size: cover;
  padding-bottom: 10.41667%;
  position: relative;
}
body .section_index .full .overlay {
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(var(--c_mainColorDarkActive), 0.7);
}
body .section_index .full .logoWrap {
  text-align: center;
  position: absolute;
  z-index: 2;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
body .section_index .full .logoWrap img {
  max-width: 80%;
  max-height: 80px;
  vertical-align: bottom;
}
body .section_index .full .logoWrap a {
  color: var(--c_textLight);
}

/* ==========================================================================
#    Tablet CSS
   ========================================================================== */
@media (min-width: 751px) and (max-width: 1000px) {
  .section_index entrance-menu ul li {
    width: 100% !important;
    margin-left: 0 !important;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
